export const parseDate = (dateStr: string): Date => {
  // Split the date string into day, month, and year parts
  const parts = dateStr.split('/')

  if (parts.length === 3) {
    const day = parseInt(parts[0], 10)
    const monthNumber = parseInt(parts[1], 10)
    const month = monthNumber - 1 // Month is 0-based, so subtract 1
    const year = parseInt(parts[2], 10)

    // Create a Date object
    const parsedDate = new Date(year, month, day)

    // Check if the parsedDate is valid
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate
    }
  }

  // Return null if the date string could not be parsed
  throw Error('date cant be null')
}

export const formatDate = (date: Date): string => {
  // Get the day, month, and year from the Date object
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Month is 0-based, so add 1
  const year = date.getFullYear()

  // Construct the formatted date string
  const formattedDate = `${day}/${month}/${year}`

  return formattedDate
}

export const dateFromDatePicker = (date: Date): Date => {
  return new Date(date)
}

export const getDate17YearsAgo = (): Date => {
  const currentDate = new Date()
  const year17YearsAgo = currentDate.getFullYear() - 17

  // Set the date to 17 years ago
  const date17YearsAgo = new Date(currentDate)
  date17YearsAgo.setFullYear(year17YearsAgo)

  return date17YearsAgo
}
